/** @deprecated import from '@famly/stat_ts-utils_non-empty-array */
export const isNonEmpty = (arr) => arr.length > 0;
/** @deprecated import from '@famly/stat_ts-utils_non-empty-array */
export const map = (arr, fn) => arr.map(fn);
/** @deprecated import from '@famly/stat_ts-utils_non-empty-array */
export const flatMap = (arr, fn) => arr.flatMap(fn);
/** @deprecated import from '@famly/stat_ts-utils_non-empty-array */
export const head = ([first]) => first;
/** @deprecated import from '@famly/stat_ts-utils_non-empty-array */
export function every(arr, fn) {
    return arr.every(fn);
}
/** @deprecated import from '@famly/stat_ts-utils_non-empty-array */
export const append = (element, nonEmptyArray) => [...nonEmptyArray, element];
/** @deprecated import from '@famly/stat_ts-utils_non-empty-array */
export const insertAtIndex = (element, idx, nonEmptyArray) => {
    const newElements = [...nonEmptyArray.slice(0, idx), element, ...nonEmptyArray.slice(idx)];
    return newElements;
};
/** @deprecated import from '@famly/stat_ts-utils_non-empty-array */
export const fromElement = (element) => [element];
/** @deprecated import from '@famly/stat_ts-utils_non-empty-array */
export const last = (arr) => arr[arr.length - 1];
/** @deprecated import from '@famly/stat_ts-utils_non-empty-array */
export const middle = (arr) => arr[Math.floor(arr.length / 2)];
/** @deprecated import from '@famly/stat_ts-utils_non-empty-array */
export const sort = (arr, fn) => 
// eslint-disable-next-line local-rules/no-mutable-array-methods -- pre-existing mutating array call flagged when local-rules/no-mutable-array-methods was added; migrate to the immutable equivalent (toSorted/toReversed/toSpliced) separately
[...arr].sort(fn);
/** @deprecated import from '@famly/stat_ts-utils_non-empty-array */
export const nonEmptyArray = (arr) => arr;
/** @deprecated import from '@famly/stat_ts-utils_non-empty-array */
export const nonEmptyEvery = (arr, fn) => isNonEmpty(arr) && arr.every(fn);
